import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import './InfoBlog.css';
import authors from 'config/authors';
import {months} from 'config/dictionary';
import iconDate from 'images/icon-date.svg';

class InfoBlog extends Component {

  render() {
    const article = this.props.article;
    const date = article.date;
    const author = authors[article.nickname];
    const dateStr = `${months[date.getMonth()]} ${date.getDay()}, ${date.getFullYear()}`;

    return (
      <div className="c-info-blog">
        <Link className={'author ' + article.nickname} to={'/authors/' + article.nickname}>
          <img src={author.photo} alt={article.nickname}/>
          <span>{author.name}</span>
        </Link>

        <div className="date">
          <img src={iconDate} alt="icon date"/>
          <span>{dateStr}</span>
        </div>
      </div>
    );
  }
}

export default InfoBlog;



// WEBPACK FOOTER //
// ./src/components/common/infoBlog/InfoBlog.jsx